import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Api from 'api';

class CreateTypes extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'CreateTypes';
    this.state = {
      types : [],
      newValue : '',
      loading : false,
    }

    this.handleChange = this.handleChange.bind(this);
    this.deleteType = this.deleteType.bind(this);
    this.addType = this.addType.bind(this);
  }
  static propTypes = {
    accountId : PropTypes.string,
    entity : PropTypes.string,
    field : PropTypes.string,
  }
  componentWillMount() {
    const { entity, field } = this.props;
    this.setState({loading: true});

    Api.getTypes(entity, field)
      .then(types => this.setState({types, loading : false}))
      .catch(error => {
        this.props.notify({message : error.message});
        this.setState({loading : false});
      });
  }
  handleChange(event) {
    this.setState({newValue : event.target.value});
  }
  deleteType(deleteValue) {
    const { types } = this.state;
    const { entity, field } = this.props;
    this.setState({
      types : this.state.types.filter(({value}) => value != deleteValue),
      loading : true
    }, () => {
      Api.setTypes(this.state.types, entity, field)
        .then(types => {
          this.setState({types, loading : false, newValue : ''});
        })
        .catch(error => {
          this.setState({loading : false});
          this.props.notify({message : error.message})
        });
    })
  }
  addType(addValue) {
    const { entity, field } = this.props;
    const { types } = this.state;
    this.setState({
      types : [...types.filter(({value}) => value != addValue), {value : addValue, type : field}],
      loading : true
    }, () => {
      Api.setTypes(this.state.types, entity, field)
        .then(types => {
          this.setState({types, loading : false, newValue : ''});
        })
        .catch(error => {
          this.setState({loading : false});
          this.props.notify({message : error.message})
        });
    })
  }
  render() {
    const { types , newValue, loading } = this.state;
    return(
      <div>
        {loading ? (
          <div className="alert alert-info text-center"><i className="fa fa-spinner fa-spin fa-2x"></i> Loading</div>
        ) : (
          <div>
            <ul className="list-group mb-sm">
              {types.length == 0 ?
                <li className="list-group-item disabled text-center">None Created</li>:
              types.map(({value}, index) =>
                <li key={index} className="list-group-item">{value} <span onClick={e => this.deleteType(value)} className="pull-right"><i className="fa fa-minus"></i></span></li>
              )}
            </ul>
          </div>
        )}
        <span className="input-group">
          <input type="text" className="form-control" value={newValue} onChange={this.handleChange} />
          <span onClick={e => this.addType(this.state.newValue)} className="input-group-addon"><i className="fa fa-plus"></i> Add</span>
        </span>
      </div>
    )
  }
}

const mapStateToProps = ({connection}) => ({ accountId : connection.user ? connection.user.account_owner || connection.user._id : undefined });

export default connect(mapStateToProps, Actions)(CreateTypes);



// WEBPACK FOOTER //
// ./src/browser/components/ui/create-types.js